import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Card } from 'antd'
import {
  CheckCircleFilled,
  CloseCircleFilled,
  MinusSquareOutlined,
  CheckSquareOutlined,
} from '@ant-design/icons'
import '../../css/patient.scss'
import _ from 'lodash'
import moment from 'moment'
import util from '../../util/util'
import serviceInterface from '../../services/service.interface'
// import Todo from '../../images/todo.png';
import Todo from '../../images/box.svg'

const PatientDevices = (props) => {
  var renderDevices = () => {
    console.log('day==>', props)
    return props.devices
      ? props.devices.map((device) => {
          var day = util.isSame(props.date, new Date())
            ? 'today'
            : ' : ' + moment(props.date).format('MM-DD')

          // var showRepeat = !(device.time && parseInt(device.time) > 1)

          // TracPatch's "measurement" is the Progress Test (active ROM), which
          // is recorded outside the device timesheet — so device.status stays
          // false even when it's done. Treat it as complete when a Progress Test
          // was completed this day (romDone), matching the patient app.
          var isTracPatch = !!(
            device &&
            ((device.display_name || '')
              .toLowerCase()
              .includes('tracpatch') ||
              (device.device_type || '').toLowerCase() === 'tracpatch')
          )
          var done = device.status || (isTracPatch && props.romDone)

          return (
            <Row className='exerciseRow' align='top'>
              <Col flex={'10px'}> &nbsp;</Col>
              <Col flex={'20px'}>
                <CheckSquareOutlined
                  className='checkIcon'
                  hidden={!done}
                />
                {!done &&
                  (util.isSame(props.date, new Date()) ||
                  util.isAfter(new Date(), props.date) ? (
                    <img
                      style={{ marginBottom: 2.5 }}
                      height={16}
                      width={16}
                      src={Todo}
                    />
                  ) : (
                    <MinusSquareOutlined
                      className='closeIcon'
                      hidden={done}
                    />
                  ))}
              </Col>
              <Col flex={'auto'}>
                <Row className='exerciseHeader'>{device.display_name}</Row>
                <Row className='exerciseDescp'>
                  <span className={'descp'}>
                    <span>
                      {`${parseInt(device.time) == 1 ? 'once' : device.time + ' times'}  a day.`}
                    </span>
                  </span>
                </Row>
              </Col>
            </Row>
          )
        })
      : null
  }

  return <Col className='exerciseContainer'>{renderDevices()}</Col>
}

PatientDevices.propTypes = {
  patient: PropTypes.object,
  date: PropTypes.object,
  devices: PropTypes.array,
  romDone: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    patient: state.patient.patient,
  }
}

export default connect(mapStateToProps, null)(PatientDevices)
